import { useCallback, useContext, useEffect } from 'react';

import { Tabs } from '@hdi-seguros/web-components.tabs';
import { ActionButton } from '@hdi-seguros/web-components.action-button';

import {
  GenericDataFormContext,
  PLAN_TYPE,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';

import { StepTwoFormContext } from '../../../StepTwo/contexts/StepTwoForm';
import { StepThreeFormContext } from '../../contexts/StepThreeForm';

import { HomePaymentMethods, Summary } from '../';
import { Form, RowSize } from '../../../../../../../../../shared/components';

import {
  generateInputID,
  getCoverageAndActivityKeyByID,
} from '../../../../../AP/Steps/StepThree/components/Quotation/utils';

import { useGenerateDataTable } from '../HomeFormByTabClosed/utils/generate-data-table';

import './index.css';

export const HomeQuotation = () => {
  const {
    quotationResponse,
    labelButton,
    setLabelButton,
    quotationResponseClosed,
    clearPrimaFieldsOnFormChange,
    handlerOnClick,
    handlePressTab,
    quotationTabs,
    activeTab,
    stepThreeHomeQuotationForm,
    setPlanSelectedSummary,
    createTabs,
  } = useContext(StepThreeFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);

  const { planTypeSelected } = useContext(StepTwoFormContext);
  const { allCoveragesPerPlan, setFormValues } = useContext(GenericDataFormContext)

  const { columnsDataTitles } = useGenerateDataTable();

  const onPressBackButton = useCallback(async () => {
    if(planTypeSelected === PLAN_TYPE.OPEN) setFormValues(stepThreeHomeQuotationForm.getFieldsValue());
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.TWO);
    setPlanSelectedSummary('');
  }, [
    quotationResponse, 
    setLabelButton, 
    setCurrentStep, 
    setPlanSelectedSummary,
    setFormValues,
    planTypeSelected,
    stepThreeHomeQuotationForm,
  ]);

  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      if (quotationResponseClosed.length) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } =
        getCoverageAndActivityKeyByID(nameOfFieldChanged);

      const tabKey = activityKey?.split('-')[2];

      const planSelected = stepThreeHomeQuotationForm?.getFieldValue(
        `plan-tab-${tabKey}`
      );

      const allCoveragesByTab = allCoveragesPerPlan.find(
        (el) => String(el.plan as string) === String(planSelected)
      )?.coverages;

      //* Verifico si la cobertura que modifique es alguna de las que dependen otras..
      const coverageCode = allCoveragesByTab?.find(
        (el) => el.id === id
      )?.codigo;

      if (coverageCode) {
        //* Tengo que verificar ahora si en las coberturas disponibles, alguna de ellas tiene relacion con este coverageCode.
        const relatedCoverages = allCoveragesByTab?.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        //* Ahora tendria que setear en el formulario correspondiente, es decir, cada cobertura en la actividad correspondiente.
        relatedCoverages.forEach(({ id, porcentajeSumaAsegegurada }) => {
          const checkboxName = generateInputID(id, activityKey, 'checkbox');
          if (stepThreeHomeQuotationForm.getFieldValue(checkboxName)) {
            const inputName = generateInputID(id, activityKey);
            stepThreeHomeQuotationForm.setFieldValue(
              inputName,
              Math.round(
                valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
              )
            );
          }
        });
      }
    },
    [
      setLabelButton,
      allCoveragesPerPlan,
      stepThreeHomeQuotationForm,
      quotationResponse,
      quotationResponseClosed,
      clearPrimaFieldsOnFormChange,
    ]
  );

  useEffect(() => {
    createTabs();
  }, [createTabs])

  return (
    <div className='home-step-three-container-div'>
      {planTypeSelected === PLAN_TYPE.OPEN ? (
        <>
          <Form
            formProps={{
              form: stepThreeHomeQuotationForm,
              name: 'quotation-home-tab-form',
              onFieldsChange: onChangeForm,
            }}
          >
            <Tabs
              handlePressTab={handlePressTab}
              activeKey={activeTab}
              items={quotationTabs}
            />
          </Form>
          {quotationResponse && (
            <>
              <HomePaymentMethods />

              <Summary />
            </>
          )}
        </>
      ) : (
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      )}

      {(columnsDataTitles ?? []).length === 0 &&
      planTypeSelected === PLAN_TYPE.CLOSED ? (
        <RowSize className='steps-buttons-container'>
          <ActionButton
            onClick={() => setCurrentStep(QuotationStep.TWO)}
            label='Anterior'
            className='steps-buttons'
            type='secondary'
          />
        </RowSize>
      ) : (
        <QuotationStepButtons
          label={labelButton}
          onClick={handlerOnClick}
          onPressBackButton={onPressBackButton}
        />
      )}
    </div>
  );
};
